import { useNumericParams } from '@domain-group/react-hooks'

import useReduxAction from '@hooks/useReduxAction'

import type { ModuleState } from '@redux/modules/types'

import TrainingCourseEditRoutes from './routes'

const TrainingCourseEdit = () => {
  const { trainingCourseId } = useNumericParams()

  useReduxAction(
    'trainingCourses',
    'loadTrainingCourse',
    {
      entityId: trainingCourseId,
    },
    [trainingCourseId],
    {
      dispatchAction: (action: Function, requestOptions) => action(trainingCourseId, requestOptions),
      shouldPerformFn: ({ loading }: ModuleState) => !!trainingCourseId && !loading,
    },
  )

  return (
    <TrainingCourseEditRoutes />
  )
}

export default TrainingCourseEdit
